import { createAsyncThunk } from "@reduxjs/toolkit";
import { types } from "@vilocnv/allsetra-core";
import { RootState } from "app/store";
import { ObjectForMapRequestDto } from "domain/objects/entities/dtos/object-for-map-request.dto";
import { ObjectLocationReportedEventDto } from "domain/objects/entities/dtos/object-location-reported-event.dto";
import { mapObjectLocationReportedEventToObject } from "domain/objects/entities/mappers/map-object-location-reported-event-to-object.mapper";
import getObjectDataForMapAction from "./get-object-data-for-map.action";

const onObjectLocationReportedEventAction = createAsyncThunk<
  types.IObject | undefined,
  {
    objectLocationEventData: ObjectLocationReportedEventDto | undefined;
    accountId: string | null;
  },
  { state: RootState }
>("objects/v2/onObjectLocationReportedEvent", async (payload, thunkAPI) => {
  try {
    const state = thunkAPI.getState();
    const { objectLocationEventData, accountId } = payload;

    if (!objectLocationEventData) {
      return;
    }

    const object = state.rootReducer.objectsStore.objects.find(
      (obj) => obj.uniqueId === objectLocationEventData?.uniqueId
    );

    if (
      accountId &&
      object &&
      object?.uniqueId ===
        state.rootReducer.objectsStore.selectedObject?.uniqueId
    ) {
      const objectForMapRequestData: ObjectForMapRequestDto = {
        accountId: accountId,
        objectId: object.uniqueId
      };
      thunkAPI.dispatch(getObjectDataForMapAction(objectForMapRequestData));
    }

    const newObject = mapObjectLocationReportedEventToObject(
      objectLocationEventData,
      object
    );

    return newObject;
  } catch (e: any) {
    throw new Error(e);
  }
});

export default onObjectLocationReportedEventAction;
